import { css } from "lit";
/*
 * Layout classes that needs to be included for the positioning of the callout to work.
 */
export const styles = css `
	.place-self-auto {
		place-self: auto;
	}
	.place-self-start {
		place-self: start;
	}
	.place-self-end {
		place-self: end;
	}
	.place-self-center {
		place-self: center;
	}
	.place-self-stretch {
		place-self: stretch;
	}

	.place-items-start {
		place-items: start;
	}
	.place-items-end {
		place-items: end;
	}
	.place-items-center {
		place-items: center;
	}
	.place-items-stretch {
		place-items: stretch;
	}

	.place-content-center {
		place-content: center;
	}
	.place-content-start {
		place-content: start;
	}
	.place-content-end {
		place-content: end;
	}
	.place-content-between {
		place-content: space-between;
	}
	.place-content-around {
		place-content: space-around;
	}
	.place-content-evenly {
		place-content: space-evenly;
	}

	.self-auto {
		align-self: auto;
	}
	.self-start {
		align-self: flex-start;
	}
	.self-center {
		align-self: center;
	}
	.self-end {
		align-self: flex-end;
	}
	.self-stretch {
		align-self: stretch;
	}

	.items-baseline {
		align-items: baseline;
	}
	.items-stretch {
		align-items: stretch;
	}
	.items-start {
		align-items: flex-start;
	}
	.items-center {
		align-items: center;
	}
	.items-end {
		align-items: flex-end;
	}

	.content-start {
		align-content: flex-start;
	}
	.content-center {
		align-content: center;
	}
	.content-end {
		align-content: flex-end;
	}
	.content-between {
		align-content: space-between;
	}
	.content-around {
		align-content: space-around;
	}
	.content-evenly {
		align-content: space-evenly;
	}

	.justify-self-auto {
		justify-self: auto;
	}
	.justify-self-start {
		justify-self: start;
	}
	.justify-self-center {
		justify-self: center;
	}
	.justify-self-end {
		justify-self: end;
	}
	.justify-self-stretch {
		justify-self: stretch;
	}

	.justify-items-start {
		justify-items: start;
	}
	.justify-items-center {
		justify-items: center;
	}
	.justify-items-end {
		justify-items: end;
	}
	.justify-items-stretch {
		justify-items: stretch;
	}

	.justify-start {
		justify-content: flex-start;
	}
	.justify-center {
		justify-content: center;
	}
	.justify-end {
		justify-content: flex-end;
	}
	.justify-between {
		justify-content: space-between;
	}
	.justify-around {
		justify-content: space-around;
	}
	.justify-evenly {
		justify-content: space-evenly;
	}

	.gap-0 {
		gap: 0;
	}
	.gap-1 {
		gap: 0.25rem;
	}
	.gap-2 {
		gap: 0.5rem;
	}
	.gap-4 {
		gap: 1rem;
	}
	.gap-6 {
		gap: 1.5rem;
	}
	.gap-8 {
		gap: 2rem;
	}
	.gap-10 {
		gap: 2.5rem;
	}
	.gap-12 {
		gap: 3rem;
	}
	.gap-14 {
		gap: 3.5rem;
	}
	.gap-16 {
		gap: 4rem;
	}

	.gap-x-0 {
		column-gap: 0;
	}
	.gap-x-1 {
		column-gap: 0.25rem;
	}
	.gap-x-2 {
		column-gap: 0.5rem;
	}
	.gap-x-4 {
		column-gap: 1rem;
	}
	.gap-x-6 {
		column-gap: 1.5rem;
	}
	.gap-x-8 {
		column-gap: 2rem;
	}
	.gap-x-10 {
		column-gap: 2.5rem;
	}
	.gap-x-12 {
		column-gap: 3rem;
	}
	.gap-x-14 {
		column-gap: 3.5rem;
	}
	.gap-x-16 {
		column-gap: 4rem;
	}

	.gap-y-0 {
		row-gap: 0;
	}
	.gap-y-1 {
		row-gap: 0.25rem;
	}
	.gap-y-2 {
		row-gap: 0.5rem;
	}
	.gap-y-4 {
		row-gap: 1rem;
	}
	.gap-y-6 {
		row-gap: 1.5rem;
	}
	.gap-y-8 {
		row-gap: 2rem;
	}
	.gap-y-10 {
		row-gap: 2.5rem;
	}
	.gap-y-12 {
		row-gap: 3rem;
	}
	.gap-y-14 {
		row-gap: 3.5rem;
	}
	.gap-y-16 {
		row-gap: 4rem;
	}

	.order-1 {
		order: 1;
	}
	.order-2 {
		order: 2;
	}
	.order-3 {
		order: 3;
	}
	.order-4 {
		order: 4;
	}
	.order-5 {
		order: 5;
	}
	.order-6 {
		order: 6;
	}
	.order-7 {
		order: 7;
	}
	.order-8 {
		order: 8;
	}
	.order-9 {
		order: 9;
	}
	.order-10 {
		order: 10;
	}
	.order-11 {
		order: 11;
	}
	.order-12 {
		order: 12;
	}
	.order-none {
		order: 0;
	}
	.order-first {
		order: -9999;
	}
	.order-last {
		order: 9999;
	}

	.flex-nowrap {
		flex-wrap: nowrap;
	}
	.flex-wrap {
		flex-wrap: wrap;
	}
	.flex-wrap-reverse {
		flex-wrap: wrap-reverse;
	}

	.shrink {
		flex-shrink: 1;
	}
	.shrink-0 {
		flex-shrink: 0;
	}

	.grow {
		flex-grow: 1;
	}
	.grow-0 {
		flex-grow: 0;
	}

	.flex-row {
		flex-direction: row;
	}
	.flex-row-reverse {
		flex-direction: row-reverse;
	}
	.flex-col {
		flex-direction: column;
	}
	.flex-col-reverse {
		flex-direction: column-reverse;
	}

	.basis-1 {
		flex-basis: 0.25rem;
	}
	.basis-2 {
		flex-basis: 0.5rem;
	}
	.basis-4 {
		flex-basis: 1rem;
	}
	.basis-8 {
		flex-basis: 2rem;
	}
	.basis-16 {
		flex-basis: 4rem;
	}
	.basis-1\/5 {
		flex-basis: 20%;
	}

	.flex-initial {
		flex: 0 1 auto;
	}
	.flex-1 {
		flex: 1 1 0%;
	}
	.flex-auto {
		flex: 1 1 auto;
	}
	.flex-none {
		flex: none;
	}

	.space-x-0 > * + * {
		margin-left: 0;
	}
	.space-x-1 > * + * {
		margin-left: 0.25rem;
	}
	.space-x-2 > * + * {
		margin-left: 0.5rem;
	}
	.space-x-4 > * + * {
		margin-left: 1rem;
	}
	.space-x-6 > * + * {
		margin-left: 1.5rem;
	}
	.space-x-8 > * + * {
		margin-left: 2rem;
	}
	.space-x-10 > * + * {
		margin-left: 2.5rem;
	}
	.space-x-12 > * + * {
		margin-left: 3rem;
	}
	.space-x-14 > * + * {
		margin-left: 3.5rem;
	}
	.space-x-16 > * + * {
		margin-left: 4rem;
	}

	.space-y-0 > * + * {
		margin-top: 0;
	}
	.space-y-1 > * + * {
		margin-top: 0.25rem;
	}
	.space-y-2 > * + * {
		margin-top: 0.5rem;
	}
	.space-y-4 > * + * {
		margin-top: 1rem;
	}
	.space-y-6 > * + * {
		margin-top: 1.5rem;
	}
	.space-y-8 > * + * {
		margin-top: 2rem;
	}
	.space-y-10 > * + * {
		margin-top: 2.5rem;
	}
	.space-y-12 > * + * {
		margin-top: 3rem;
	}
	.space-y-14 > * + * {
		margin-top: 3.5rem;
	}
	.space-y-16 > * + * {
		margin-top: 4rem;
	}

	.space-x-reverse > * + * {
		margin-right: 0;
		margin-left: 0;
	}
	.space-y-reverse > * + * {
		margin-bottom: 0;
		margin-top: 0;
	}

	.m-0 {
		margin: 0;
	}
	.m-1 {
		margin: 0.25rem;
	}
	.m-2 {
		margin: 0.5rem;
	}
	.m-4 {
		margin: 1rem;
	}
	.m-6 {
		margin: 1.5rem;
	}
	.m-8 {
		margin: 2rem;
	}
	.m-10 {
		margin: 2.5rem;
	}
	.m-12 {
		margin: 3rem;
	}
	.m-14 {
		margin: 3.5rem;
	}
	.m-16 {
		margin: 4rem;
	}

	.mt-0 {
		margin-top: 0;
	}
	.mt-1 {
		margin-top: 0.25rem;
	}
	.mt-2 {
		margin-top: 0.5rem;
	}
	.mt-4 {
		margin-top: 1rem;
	}
	.mt-6 {
		margin-top: 1.5rem;
	}
	.mt-8 {
		margin-top: 2rem;
	}
	.mt-10 {
		margin-top: 2.5rem;
	}
	.mt-12 {
		margin-top: 3rem;
	}
	.mt-14 {
		margin-top: 3.5rem;
	}
	.mt-16 {
		margin-top: 4rem;
	}

	.mr-0 {
		margin-right: 0;
	}
	.mr-1 {
		margin-right: 0.25rem;
	}
	.mr-2 {
		margin-right: 0.5rem;
	}
	.mr-4 {
		margin-right: 1rem;
	}
	.mr-6 {
		margin-right: 1.5rem;
	}
	.mr-8 {
		margin-right: 2rem;
	}
	.mr-10 {
		margin-right: 2.5rem;
	}
	.mr-12 {
		margin-right: 3rem;
	}
	.mr-14 {
		margin-right: 3.5rem;
	}
	.mr-16 {
		margin-right: 4rem;
	}

	.mb-0 {
		margin-bottom: 0;
	}
	.mb-1 {
		margin-bottom: 0.25rem;
	}
	.mb-2 {
		margin-bottom: 0.5rem;
	}
	.mb-4 {
		margin-bottom: 1rem;
	}
	.mb-6 {
		margin-bottom: 1.5rem;
	}
	.mb-8 {
		margin-bottom: 2rem;
	}
	.mb-10 {
		margin-bottom: 2.5rem;
	}
	.mb-12 {
		margin-bottom: 3rem;
	}
	.mb-14 {
		margin-bottom: 3.5rem;
	}
	.mb-16 {
		margin-bottom: 4rem;
	}

	.ml-0 {
		margin-left: 0;
	}
	.ml-1 {
		margin-left: 0.25rem;
	}
	.ml-2 {
		margin-left: 0.5rem;
	}
	.ml-4 {
		margin-left: 1rem;
	}
	.ml-6 {
		margin-left: 1.5rem;
	}
	.ml-8 {
		margin-left: 2rem;
	}
	.ml-10 {
		margin-left: 2.5rem;
	}
	.ml-12 {
		margin-left: 3rem;
	}
	.ml-14 {
		margin-left: 3.5rem;
	}
	.ml-16 {
		margin-left: 4rem;
	}

	.mx-0 {
		margin-left: 0;
		margin-right: 0;
	}
	.mx-1 {
		margin-left: 0.25rem;
		margin-right: 0.25rem;
	}
	.mx-2 {
		margin-left: 0.5rem;
		margin-right: 0.5rem;
	}
	.mx-4 {
		margin-left: 1rem;
		margin-right: 1rem;
	}
	.mx-6 {
		margin-left: 1.5rem;
		margin-right: 1.5rem;
	}
	.mx-8 {
		margin-left: 2rem;
		margin-right: 2rem;
	}
	.mx-10 {
		margin-left: 2.5rem;
		margin-right: 2.5rem;
	}
	.mx-12 {
		margin-left: 3rem;
		margin-right: 3rem;
	}
	.mx-14 {
		margin-left: 3.5rem;
		margin-right: 3.5rem;
	}
	.mx-16 {
		margin-left: 4rem;
		margin-right: 4rem;
	}

	.my-0 {
		margin-top: 0;
		margin-bottom: 0;
	}
	.my-1 {
		margin-top: 0.25rem;
		margin-bottom: 0.25rem;
	}
	.my-2 {
		margin-top: 0.5rem;
		margin-bottom: 0.5rem;
	}
	.my-4 {
		margin-top: 1rem;
		margin-bottom: 1rem;
	}
	.my-6 {
		margin-top: 1.5rem;
		margin-bottom: 1.5rem;
	}
	.my-8 {
		margin-top: 2rem;
		margin-bottom: 2rem;
	}
	.my-10 {
		margin-top: 2.5rem;
		margin-bottom: 2.5rem;
	}
	.my-12 {
		margin-top: 3rem;
		margin-bottom: 3rem;
	}
	.my-14 {
		margin-top: 3.5rem;
		margin-bottom: 3.5rem;
	}
	.my-16 {
		margin-top: 4rem;
		margin-bottom: 4rem;
	}

	.p-0 {
		padding: 0;
	}
	.p-1 {
		padding: 0.25rem;
	}
	.p-2 {
		padding: 0.5rem;
	}
	.p-4 {
		padding: 1rem;
	}
	.p-6 {
		padding: 1.5rem;
	}
	.p-8 {
		padding: 2rem;
	}
	.p-10 {
		padding: 2.5rem;
	}
	.p-12 {
		padding: 3rem;
	}
	.p-14 {
		padding: 3.5rem;
	}
	.p-16 {
		padding: 4rem;
	}

	.pt-0 {
		padding-top: 0;
	}
	.pt-1 {
		padding-top: 0.25rem;
	}
	.pt-2 {
		padding-top: 0.5rem;
	}
	.pt-4 {
		padding-top: 1rem;
	}
	.pt-6 {
		padding-top: 1.5rem;
	}
	.pt-8 {
		padding-top: 2rem;
	}
	.pt-10 {
		padding-top: 2.5rem;
	}
	.pt-12 {
		padding-top: 3rem;
	}
	.pt-14 {
		padding-top: 3.5rem;
	}
	.pt-16 {
		padding-top: 4rem;
	}

	.pr-0 {
		padding-right: 0;
	}
	.pr-1 {
		padding-right: 0.25rem;
	}
	.pr-2 {
		padding-right: 0.5rem;
	}
	.pr-4 {
		padding-right: 1rem;
	}
	.pr-6 {
		padding-right: 1.5rem;
	}
	.pr-8 {
		padding-right: 2rem;
	}
	.pr-10 {
		padding-right: 2.5rem;
	}
	.pr-12 {
		padding-right: 3rem;
	}
	.pr-14 {
		padding-right: 3.5rem;
	}
	.pr-16 {
		padding-right: 4rem;
	}

	.pb-0 {
		padding-bottom: 0;
	}
	.pb-1 {
		padding-bottom: 0.25rem;
	}
	.pb-2 {
		padding-bottom: 0.5rem;
	}
	.pb-4 {
		padding-bottom: 1rem;
	}
	.pb-6 {
		padding-bottom: 1.5rem;
	}
	.pb-8 {
		padding-bottom: 2rem;
	}
	.pb-10 {
		padding-bottom: 2.5rem;
	}
	.pb-12 {
		padding-bottom: 3rem;
	}
	.pb-14 {
		padding-bottom: 3.5rem;
	}
	.pb-16 {
		padding-bottom: 4rem;
	}

	.pl-0 {
		padding-left: 0;
	}
	.pl-1 {
		padding-left: 0.25rem;
	}
	.pl-2 {
		padding-left: 0.5rem;
	}
	.pl-4 {
		padding-left: 1rem;
	}
	.pl-6 {
		padding-left: 1.5rem;
	}
	.pl-8 {
		padding-left: 2rem;
	}
	.pl-10 {
		padding-left: 2.5rem;
	}
	.pl-12 {
		padding-left: 3rem;
	}
	.pl-14 {
		padding-left: 3.5rem;
	}
	.pl-16 {
		padding-left: 4rem;
	}

	.px-0 {
		padding-left: 0;
		padding-right: 0;
	}
	.px-1 {
		padding-left: 0.25rem;
		padding-right: 0.25rem;
	}
	.px-2 {
		padding-left: 0.5rem;
		padding-right: 0.5rem;
	}
	.px-4 {
		padding-left: 1rem;
		padding-right: 1rem;
	}
	.px-6 {
		padding-left: 1.5rem;
		padding-right: 1.5rem;
	}
	.px-8 {
		padding-left: 2rem;
		padding-right: 2rem;
	}
	.px-10 {
		padding-left: 2.5rem;
		padding-right: 2.5rem;
	}
	.px-12 {
		padding-left: 3rem;
		padding-right: 3rem;
	}
	.px-14 {
		padding-left: 3.5rem;
		padding-right: 3.5rem;
	}
	.px-16 {
		padding-left: 4rem;
		padding-right: 4rem;
	}

	.py-0 {
		padding-top: 0;
		padding-bottom: 0;
	}
	.py-1 {
		padding-top: 0.25rem;
		padding-bottom: 0.25rem;
	}
	.py-2 {
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
	}
	.py-4 {
		padding-top: 1rem;
		padding-bottom: 1rem;
	}
	.py-6 {
		padding-top: 1.5rem;
		padding-bottom: 1.5rem;
	}
	.py-8 {
		padding-top: 2rem;
		padding-bottom: 2rem;
	}
	.py-10 {
		padding-top: 2.5rem;
		padding-bottom: 2.5rem;
	}
	.py-12 {
		padding-top: 3rem;
		padding-bottom: 3rem;
	}
	.py-14 {
		padding-top: 3.5rem;
		padding-bottom: 3.5rem;
	}
	.py-16 {
		padding-top: 4rem;
		padding-bottom: 4rem;
	}
`;
//# sourceMappingURL=layout-styles.js.map